import { render, staticRenderFns } from "./InternetBankingEnrolment.vue?vue&type=template&id=78abce09&"
import script from "./InternetBankingEnrolment.vue?vue&type=script&lang=js&"
export * from "./InternetBankingEnrolment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports